import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { LegalsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const LegalList = Loader(lazy(() => import('../../content/pages/Legals/LegalsList')));
const LegalsCreate = Loader(lazy(() => import('../../content/pages/Legals/LegalCreate')));
const LegalUpdate = Loader(lazy(() => import('../../content/pages/Legals/LegalUpdate')));

export const createLegalsRoutes = () => ({
  path: 'settings/legals',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['settingsView']} should404>
          <Navigate to="/settings/legals/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['legalCreate']} should404>
          <LegalsProvider>
            <LegalsCreate />
          </LegalsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['settingsView']} should404>
          <LegalsProvider>
            <LegalList />
          </LegalsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:legalId/update`,
      element: (
        <PermissionsGuard allowedPermissions={['legalCreate']} should404>
          <LegalsProvider>
            <LegalUpdate />
          </LegalsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
